import { supabase } from "../utils/API";
import { Auth, User } from "../models/User";
import { updateUserActivity } from "./UserService";
import moment from "moment";
import axios from "axios";


export async function login(email: string, password: string): Promise<Auth> {
  supabase.auth.getSession();
  try {
    // sends a signIn request to supabase, authenticating the user

    // const user = await getUserByEmailOne(email);

    // if ("admin" == "admin") {
    //   return {
    //     success: false,
    //     access_token: "",
    //     message: "You are not authorized to login.",
    //   };
    // }
    // isMatch = await comparePassword(password, user.password as string);
    let auth: Auth = await generateToken(email, password);
    if (auth.success == true) {
      const user = await getUserByEmail(email);
      auth.user = user;
      auth.message = "";
      return auth;
    } else {
      return {
        success: false,
        access_token: "",
        user: null as unknown as User,
        message: "Username or Password is incorrect.",
      };
    }
  } catch (e: any) {
    return {
      success: false,
      access_token: "",
      user: null as unknown as User,
      message: "Oops,Something went wrong. Please try again.",
    };
  }
}



export async function generateToken(
  email: string,
  password: string
): Promise<Auth> {
  try {
    const { data, error } = await supabase.auth.signInWithPassword({
      email: email,
      password: password,
    });
    if (error) {
      return { success: false, access_token: "" };
    }
    console.log(data);
    const user = await getUserByEmail(email);
    if (user.role !== "ADMIN") {
      signOut();
      return {
        success: false,
        access_token: "",
        message: "You are not authorized to login.",
      };
    }

    return {
      access_token: data.session?.access_token as string,
      success: true,
    };
  } catch (e: any) {
    return { success: false, access_token: "" };
  }
}

export async function signOut() {
  const user = JSON.parse(localStorage.getItem("user") as string);
  // await updateUserActivity({
  //   user_id: user?.id,
  //   last_activity: new Date(Date.now()),
  // });
  localStorage.removeItem("user");
  localStorage.removeItem("access_token");
  return await supabase.auth.signOut();
}

export async function getUserByEmailOne(email: string): Promise<User> {
  const { data } = await axios.get(
    `https://smrgejlacnpeerpzxezv.supabase.co/rest/v1/users?email=eq.${email}`,
    {
      headers: {
        Authorization:
          "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNtcmdlamxhY25wZWVycHp4ZXp2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MDcxMjM5MzcsImV4cCI6MjAyMjY5OTkzN30.nacBmdMek4MeNVyLylb4MnmMztA6wIMdej_8PXULLU8", // Add your JWT token here
        apiey:
          "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNtcmdlamxhY25wZWVycHp4ZXp2Iiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTcwNzEyMzkzNywiZXhwIjoyMDIyNjk5OTM3fQ.d1pIFBYUmxao2eBTQQiPoJXChHz_SZklp4en5dYRVpM",
        "Content-Type": "application/json",
      },
    }
  );

  return data as User;
}



export async function getUserByEmail(email: string): Promise<User> {
  const { data, error } = await supabase
    .from("users")
    .select("*")
    .eq("email", email)
    .limit(1)
    .single();
  if (error) throw error;
  return data as User;
}

function getDate() {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const currentTime = moment();
  return currentTime;
}
export async function SignUp(email: string, password: string): Promise<any> {
  const { data, error } = await supabase.auth.signUp({
    email: email,
    password: password,
  });
  if (error) throw error;
  return data;
}
